export const CROSS_CUTTING_TASK = 'crossCuttingTask';

export const CROSS_CUTTING_TASK_ACTIONS_NAME = {
  getCrossCuttingTasksMpk: `${CROSS_CUTTING_TASK}/getCrossCuttingTasksMpk`,
} as const;

export const CROSS_CUTTING_TASK_MUTATIONS_NAME = {
  setCrossCuttingTaskMpk: `setCrossCuttingTaskMpk`,
} as const;

export const CROSS_CUTTING_TASK_GETTERS_NAME = {
  getCrossCuttingTasksMpk: `${CROSS_CUTTING_TASK}/getCrossCuttingTasksMpk`,
} as const;
